// Set when Promote runs as a Module Federation remote (at mount); drives cookie
// auth, bare chrome and no login redirects. `orgId` is the host's active
// Events.com org so Promote follows the host's org selection. Standalone never
// sets these.
let embedded = false;
let hostOrgId: string | undefined;

export function markEmbedded(orgId?: string): void {
  embedded = true;
  hostOrgId = orgId;
}

export function isEmbedded(): boolean {
  return embedded;
}

export function getEmbeddedOrgId(): string | undefined {
  return hostOrgId;
}
